module.exports = __webpack_public_path__ + "static/media/continueStraight.347f59ef.svg";